var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEmptyPatient = function SvgIconEmptyPatient(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FB355D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.833v9.334C0 18.387 2.612 21 5.833 21h9.334C18.387 21 21 18.388 21 15.167V5.833C21 2.613 18.388 0 15.167 0H5.833C2.613 0 0 2.612 0 5.833z",
    transform: "translate(-238 -283) translate(226.556 265) translate(13 19)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-238 -283) translate(226.556 265) translate(13 19) translate(6.21 6.598)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.964,
    d: "M1.107.156C1.833.052 2.56 0 3.286 0c.726 0 1.452.052 2.178.156.636.09 1.107.635 1.107 1.277v3.82c0 .565-.366 1.063-.904 1.232-.794.248-1.588.372-2.381.372-.794 0-1.588-.124-2.381-.372C.367 6.316 0 5.818 0 5.253v-3.82C0 .791.472.247 1.107.156z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M7.689 2.378l1-.486c.4-.194.883-.027 1.077.374.05.103.078.217.08.332.008.284.011.57.011.858 0 .298-.004.595-.01.889-.012.445-.382.797-.827.786-.109-.003-.216-.028-.315-.073l-.98-.447c-.268-.123-.447-.383-.466-.677l-.003-.036c-.019-.294-.018-.59.003-.884.02-.274.183-.517.43-.636z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.929,
    cy: 1.5,
    r: 1,
    fill: "#FB355D"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEmptyPatient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-empty-patient.7c2e09d3c09e94d93892b430537f0d1b.svg";